import script from "./WelcomeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeView.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeView.vue?vue&type=style&index=0&id=8c6d2740&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c6d2740"]])

export default __exports__